<div class="row">
    <div class="col-12 col-md-6">
        <h1 class="page-header"><i class="fas fa-cog"></i> Configuracion
            @if(isReadOnly){ <small class="text-muted fs-14px ms-2">(Modo Lectura)</small> }
        </h1>
    </div>
    
    <div class="col-12 col-md-6">
        <div class=" d-md-flex fw-bold justify-content-end">
            <div class="mt-3">
                         <a href="javascript:;" class="btn btn-xs btn-outline-danger"
                         (click)="clickCloseSettingBudget()"><i
                                class="fa fa-times fa-fw me-1"></i> Cerrar</a>
            </div>
        </div>
    </div>
</div>



<div class="row">
    <div class="col-xl-8">
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3">
                <i class="fa-solid fa-square-poll-vertical fa-lg fa-fw text-dark text-opacity-50 me-1"></i> Información General </div>
            <div class="card-body">
                <form [formGroup]="formBudget">
                    <div class="mb-3"><label class="form-label">Nombre del presupuesto</label>
                    <input type="text" name="name"
                        placeholder="Nombre del presupuesto" class="form-control" formControlName="name" (change)="changeBudget($event,'name')">
                </div>
                <div class="mb-3 d-flex gap-3">
                    <div>
                        <label class="form-label">Año</label>
                        <input type="text" name="year"
                        placeholder="Año" class="form-control" formControlName="year">
                    </div>
                    <div>
                        <label class="form-label">Version</label>
                        <input type="text" name="version"
                        placeholder="Version" class="form-control" formControlName="version">
                    </div>
                    <div>
                        <label class="form-label">Estado</label>
                        <select type="text" name="status"
                        placeholder="Estado" class="form-select" formControlName="status">
                        <option *ngFor="let status of budgetStatusRef" [value]="status.id">{{status.name}}</option>
                        </select>
                    </div>
                    @if(formBudget.get('status')?.value==1){
                    <div>
                        <label class="form-label">Voto</label>
                        <input type="text" name="vote"
                        placeholder="Voto" class="form-control" formControlName="vote">
                    </div>
                }
                </div>
                

                </form>
                @if(!isReadOnly){
                <footer>
                    <button type="button" class="btn btn-success btn-sm" (click)="updateBudget()">Guardar</button>
                </footer>
                }

            </div>
        </div>
        @if(this.entitySelected?.group!='FUNDACION'){
            <div class="card border-0 mb-4">
                <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                    <div class="d-flex align-items-center justify-content-between">
                        
                        <div><i class="fas fa-coins fa-lg fa-fw text-dark text-opacity-50 me-1"></i>
                            Fondo</div>
                    </div>
                </div>
                <div class="card-body fw-bold">
                    <div class="row">
                        <ng-select  [items]="aasinetFundSelect" [closeOnSelect]="false" [(ngModel)]="selectedFund" [hideSelected]="true"
                         [multiple]="true" bindLabel="nameCode" (add)="addBudgetFund($event)" (remove)="removeBudgetFund($event)"
                        bindValue="code" [disabled]="isReadOnly">
                    </ng-select>
                    </div>
                    @if(!isReadOnly){
                    <br>
                    <div>
                        <span class="fst-italic text-muted">Al eliminar un fondo, se eliminará toda la información asociada al fondo.</span>
                    </div>
                    }
                </div>
            </div>
            }
        @if(this.entitySelected?.group!='FUNDACION'){
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3">
                <div class="d-flex justify-content-between">
                    <div>
                        <i class="fa fa-user fa-lg fa-fw text-dark text-opacity-50 me-1">
                        </i>Tipos Empleados 
                    </div>
                    @if(!isReadOnly){
                    <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
                        <a href="javascript:;" data-bs-toggle="dropdown"
                            class="text-decoration-none text-dark text-opacity-75"><i
                                class="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i> <b class="caret"></b></a>

                        <div class="dropdown-menu">
                            <a href="javascript:;" class="dropdown-item">Agregar Empleado</a>
                            
                            </div>
                    </div>
                    }
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-select  [items]="dataEmployeeType" [closeOnSelect]="false" [(ngModel)]="selectedEmployeeType" [hideSelected]="true"
                     [multiple]="true" bindLabel="nameId" (add)="addBudgetEmployeeType($event)" (remove)="removeBudgetEmployeeType($event)"
                    bindValue="id" [disabled]="isReadOnly">
                </ng-select>
                </div>
                @if(!isReadOnly){
                <br>
                <div>
                    <span class="fst-italic text-muted">Al agregar un tipo de empleado se habilita la tabulación de sueldo para presupuestar mas detalladamente sueldos.
                        <br> Al eliminar un tipo de empleado, se eliminará toda la información asociada al tipo de empleado</span>
                </div>
                }
            </div>
        </div>
        }
        @if(budgetImportLog?.length>0){
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3"><i
                    class="fa fa-exclamation-circle fa-lg fa-fw text-dark text-opacity-50 me-1"></i>Aviso
                    
           
                 </div>
          
            <div class="card-body rounded-bottom">
                <div class="alert alert-danger">
                    <span class="fst-italic text-danger fw-bold">
                        Las siguientes cuentas no estan habilitadas. Es necesario volver a presupuestar con una cuenta activa
                    </span>
                </div>
               
                <div class="table-data mt-2">
                    <table class="table table-sm ">
                        <thead>
                            <tr>
                                <th>Fondo</th>
                                <th class="text-start">N° Cuenta/Div</th>
                                <th class="">Nombre Cuenta </th>
                                <th class="text-nowrap text-end">Total</th>
          
            
                            </tr>
                        </thead>
                        <tbody>
                            <!--muestra una tabla cargando mientras se estan cargado los datos-->

                            @for(a of budgetImportLog; track a.id){
                            <tr>
                                 <td>{{a.fundCode}}</td>                               
                                <td class="text-nowrap  align-middle">
                                   <span>{{a.subAccountCode==-1?a.accountCode:a.accountCode+'/'+a.subAccountCode}}</span>
                                </td>
                                <td class="align-middle">
                                    {{a.subAccountCode==-1?a.accountDisplayName:a.accountDisplayName+' - '+a.subAccountName}}
                                    @if(a.accountHint){
                                    <i class="fas fa-question-circle" ngbTooltip="{{a.accountHint}}" placement="right"
                                        [container]="'body'">
                                    </i>
                                    }
                                </td>
                                <td class="text-nowrap align-middle text-end">
                                    <span>${{a.totalValue| number: '1.0-0'}}</span>
                                </td>

                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            
            </div>

        </div>
        }
    </div>
    <div class="col-xl-4">
       @if(this.entitySelected?.group=='FUNDACION'){
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                <div class="d-flex align-items-center justify-content-between">
                    
                    <div><i class="fas fa-coins fa-lg fa-fw text-dark text-opacity-50 me-1"></i>
                        Fondo</div>
                </div>
            </div>
            <div class="card-body fw-bold">
                <div class="row">
                    <ng-select  [items]="aasinetFundSelect" [closeOnSelect]="false" [(ngModel)]="selectedFund" [hideSelected]="true"
                     [multiple]="true" bindLabel="nameCode" (add)="addBudgetFund($event)" (remove)="removeBudgetFund($event)"
                    bindValue="code" [disabled]="isReadOnly">
                </ng-select>
                </div>
                @if(!isReadOnly){
                <br>
                <div>
                    <span class="fst-italic text-muted">Al eliminar un fondo, se eliminará toda la información asociada al fondo</span>
                </div>
                }
            </div>
        </div>
        }
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                <div class="flex-1">
                    <div>Factor REA</div>
                </div>
            </div>
            <div class="card-body fw-bold">
                @for(f of factorRea; track f.id){
                    @if(f.itemCode!=3){
                    <div class="list-group list-group-flush"><div 
                            class="list-group-item list-group-item-action d-flex p-2 align-items-center">
                            <span class="flex-1 me-3">{{f.itemCode!='500'?f.itemCode+' - ':''}}{{f.displayName}}</span>
                            <span class="badge fs-10px w-45px" [ngClass]="f?.style">{{f?.value|number:'1.2-2'}}%</span>
                            </div>
                    </div>
                    }
                }
            </div>
        </div>
        @if(this.entitySelected?.group!='FUNDACION'){
        <div class="card border-0 mb-4">
            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                <div class="flex-1">
                    <div>Factores de Presupuesto</div>
                </div>
                <div><!-- podria agregar un boton para editar los factores de presupuesto <a href="#" class="text-decoration-none text-gray-500">Manage</a> --></div>
            </div>
            <div class="card-body fw-bold">                
                @for(b of budgetFactors; track b.id){
                     <div class="list-group list-group-flush"><div 
                            class="list-group-item list-group-item-action d-flex p-2 align-items-center">
                            <div>
                                <i class="fa fa-circle fa-xs me-2 text-success"></i>
                            </div>
                            <span class="flex-1 me-3">{{b.name}}</span>
                            <span>{{b.unitSymbol||''}} {{b.value | number: '1.'+(b.decimalPlaces || 0)+'-'+(b.decimalPlaces || 0)}}</span>
                            @if(b.isEditable && !isReadOnly){
                                <button type="button" class="btn btn-outline-primary btn-xs ms-2" (click)="openModalEditFactor(b)" title="Modificar factor">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>
                            }
                            </div>
                    </div>
                }
               
            </div>
        </div>
        }
    </div>
</div>



<!--modal diverse-->

<ng-template #modal_budget let-c="close" let-d="dismiss" let-modal>

    <div class="modal-header">
        <h5 class="modal-title">{{modalHeaderBudget}}</h5>
        <span (click)="d('Cross click');isNewBudget=false;budgetFinded=false" type="button" class="btn-close bt-xs"
            data-dismiss="modal" tabindex="8">

        </span>
    </div>
    <div class="modal-body">
        <div class="panel-body panel-form">
            <form [formGroup]="formBudget">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Año</label>
                    <div class="col-md-8">
                        <input class="form-control" type="text" formControlName="year">
                        @if(formBudget.get('year')?.errors?.required && formBudget.get('year').touched){
                        <div><small class="text-danger">Año es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Descripción</label>
                    <div class="col-md-8">
                        <input type="text"
                            [class.is-invalid]="formBudget.get('name').invalid&&formBudget.get('name').touched"
                            (click)="formBudget.get('name').markAsUntouched();"
                            (focus)="formBudget.get('name').markAsUntouched();" formControlName="name" name="name"
                            class="form-control" tabindex="2" />
                        @if(formBudget.get('name')?.errors?.required && formBudget.get('name').touched){
                        <div><small class="text-danger">Descripción es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Configuración de datos</label>

                    <div class="col-md-8 d-flex align-items-center">
                        <div class="d-flex gap-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="check1" tabindex="3"
                                    [(ngModel)]="usePreviousBudget" [ngModelOptions]="{standalone: true}"
                                    (change)="changeUsePreviousBudget()">
                                <label class="form-check-label" for="check1">Cargar datos de presupuesto
                                    anteriores</label>
                            </div>
                        </div>
                    </div>
                </div>
                @if(usePreviousBudget){
                <div class="form-group row mt-1">
                    <label class="col-md-4 col-form-label"> Presupuesto anterior</label>
                    <div class="col-md-8">
                        <select class="form-select" formControlName="name">
                            <option value="">Seleccione</option>
                            @for(d of budget;track $index; let idx = $index){
                            <option value="{{d.id}}">{{d.year+'-'+d.version}}</option>
                            }
                        </select>
                    </div>
                </div>&nbsp;
                }
                @if(usePreviousBudget){
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Configuración Base</label>

                    <div class="col-md-8 d-flex align-items-center">
                        <div class="d-flex gap-1 flex-wrap">
                            <div class="form-check form-check-inline col-6"> <input class="form-check-input"
                                    type="checkbox" id="checkDepartamentos" tabindex="3"
                                    [(ngModel)]="departamentosChecked" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label" for="checkDepartamentos">Departamentos</label>
                            </div>

                            <div class="form-check form-check-inline col-6"> <input class="form-check-input"
                                    type="checkbox" id="checkCuentas" tabindex="3" [(ngModel)]="cuentasChecked"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label" for="checkCuentas">Cuentas</label>
                            </div>

                            <div class="form-check form-check-inline col-6"> <input class="form-check-input"
                                    type="checkbox" id="checkIngresos" tabindex="3" [(ngModel)]="ingresosChecked"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label" for="checkIngresos">Ingresos</label>
                            </div>

                            <div class="form-check form-check-inline col-6"> <input class="form-check-input"
                                    type="checkbox" id="checkEmpleados" tabindex="3" [(ngModel)]="empleadosChecked"
                                    [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label" for="checkEmpleados">Empleados</label>
                            </div>

                        </div>
                    </div>
                </div>
                }
            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click')"><i
                class="fas fa-times"></i>&nbsp;
            Cerrar</button>
        @if(modalHeaderBudget==='Nuevo Presupuesto'){
        <button type="button" class="btn btn-primary btn-sm" (click)="submitBudgetNew()"
            [disabled]="formBudget.pristine&&!formBudget.valid||!formBudget.valid" tabindex="4"><i
                class="fas fa-save"></i>&nbsp;Guardar</button>
        }
        @if(modalHeaderBudget==='Modificar Presupuesto'){
        <button type="button" class="btn btn-primary btn-sm" (click)="submitBudgetUpdate()"
            [disabled]="formBudget.pristine||!formBudget.valid" tabindex="4"><i
                class="fas fa-save"></i>&nbsp;Guardar</button>
        }
    </div>
</ng-template>
<!--end diverse-->

<!--modal factor-->
<ng-template #modal_factor let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">Modificar Factor: {{selectedFactor?.name}}</h5>
        <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="8">
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="formFactor">
            <div class="form-group row mb-3">
                <label class="col-md-4 col-form-label">Código</label>
                <div class="col-md-8">
                    <input type="text" [value]="selectedFactor?.code" class="form-control" disabled />
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-md-4 col-form-label">Nombre</label>
                <div class="col-md-8">
                    <input type="text" [value]="selectedFactor?.name" class="form-control" disabled />
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-md-4 col-form-label">Valor {{selectedFactor?.unitSymbol ? '(' + selectedFactor?.unitSymbol + ')' : ''}}</label>
                <div class="col-md-8">
                    <input type="text" formControlName="value" class="form-control" appNumberFormat tabindex="1"
                           [class.is-invalid]="formFactor.get('value').invalid && formFactor.get('value').touched" />
                    @if(formFactor.get('value')?.errors?.required && formFactor.get('value').touched){
                        <div><small class="text-danger">Valor es requerido.</small></div>
                    }
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click')">
            <i class="fas fa-times"></i>&nbsp;Cerrar
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="submitFactorUpdate()"
                [disabled]="formFactor.pristine || !formFactor.valid" tabindex="2">
            <i class="fas fa-save"></i>&nbsp;Actualizar
        </button>
    </div>
</ng-template>